export default __webpack_public_path__ + "static/media/alertErrorZero.380a0721.svg";